<template>
  <div class="boss-main-wrap boss-main-content-wrap">
    <setting-header
      v-if="isCompanyStaff"
      :breadcrumbs="[{ name: '求人確認' },{ name: '掲載済みの求人・応募フォームタイプ設定', pathName: 'previewJobConfirmTop' }]"
      title="掲載済みの求人プレビュー"
      class="hide-for-print"
    />
    <div
      data-test="usage-notes-and-print-button"
      class="grid-x hide-for-print"
    >
      <div class="cell auto pega-usage-notes">
        <job-preview-provision-list-link class="pega-accordion-link-header" />
      </div>
      <print-button class="cell shrink" />
    </div>
    <div
      v-if="jobInfo.isShowSPPreviewButton"
      data-test="button-area"
      class="grid-x margin-bottom-1 hide-for-print"
    >
      <div class="cell">
        <button
          class="boss-button-center pega-preview-jump-button"
          @click="openSpPreview()"
        >
          <img
            class="pega-icon-phone"
            src="@/assets/images/smartphone.png"
          >
          スマホ版プレビューはこちら
        </button>
      </div>
    </div>
    <preview-job-own-table
      v-if="!isCompanyStaff && isFinishCreated"
      :job-info="jobInfo"
    />
    <div class="pega-preview-area">
      <div
        v-if="isFinishCreated"
        class="pega-job-preview"
        data-test="job-preview-first-area"
      >
        <preview-job
          :is-show-comment="false"
          :is-show-text-count="isShowTextCount"
          :job-info="jobInfo"
          :company-interview="companyInterview"
          :company-info="companyInfo"
          :about-apply="aboutApply"
        />
        <preview-code-setting
          :is-show-comment="false"
          :code-setting="codeSetting"
          :official-company-name="companyInfo.officialCompanyName"
          :display-company-name="companyInfo.companyName"
          :company-name-kana="companyInfo.companyNameKana"
          :is-secret-plan="companyInfo.isSecretPlan"
          :is-not-output-google-for-jobs="companyInfo.isNotOutputGoogleForJobs"
          :is-only-full-remote="jobInfo.isOnlyFullRemote"
        />
        <preview-matching
          v-if="matchingSetting.isStopMatching !== null"
          :is-show-comment="false"
          :matching-setting="matchingSetting"
        />
      </div>
      <div
        v-if="isFinishCreated && personalityMatchings.length"
        class="pega-job-preview"
        data-test="job-preview-second-area"
      >
        <preview-personal-matching-status
          :is-show-comment="false"
          :personality-matching="personalityMatchings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import PreviewJobOwnTable from '@/components/organisms/PreviewJobOwnTable'
import PreviewJob from '@/components/organisms/PreviewJob'
import PreviewCodeSetting from '@/components/organisms/PreviewCodeSetting'
import PreviewMatching from '@/components/organisms/PreviewMatching'
import PreviewPersonalMatchingStatus from '@/components/organisms/PreviewPersonalMatchingStatus'
import JobPreviewProvisionListLink from '@/components/atoms/JobPreviewProvisionListLink'
import PrintButton from '@/components/atoms/PrintButton'

const USER_URL = process.env.USER_ENDPOINT
export default {
  components: {
    SettingHeader,
    PreviewJobOwnTable,
    PreviewJob,
    PreviewCodeSetting,
    PreviewMatching,
    PreviewPersonalMatchingStatus,
    JobPreviewProvisionListLink,
    PrintButton
  },
  data () {
    return {
      jobId: '',
      isCompanyStaff: true,
      isShowTextCount: false,
      isFinishCreated: false,
      apiPath: '',
      jobInfo: {},
      companyInterview: {},
      companyInfo: {},
      aboutApply: {},
      codeSetting: {},
      matchingSetting: {},
      personalityMatchings: []
    }
  },
  computed: {
    userEndPoint: () => USER_URL
  },
  async created () {
    this.jobId = this.$route.params.jobId
    this.isCompanyStaff = this.$route.name === 'previewJobConfirm'
    this.isShowTextCount = !this.$route.query.folderChildId // 過去掲載の場合はテキストカウントを非表示

    // APIをADMとBOSSで分ける
    this.apiPath = this.isCompanyStaff
      ? `/preview/confirm/jobs/${this.jobId}/`
      : `/preview/confirm/companies/${this.$route.params.companyId}/jobs/${this.jobId}/`

    this.fetchPreviewInfo()
  },
  methods: {
    fetchPreviewInfo () {
      const query = this.$route.query.folderChildId ? `?folderChildId=${this.$route.query.folderChildId}` : ''
      Promise.all([
        // 求人情報取得API
        this.$http.secured.get(this.apiPath + 'job_info' + query),
        // もっと知りたい！会社の素顔API
        this.$http.secured.get(this.apiPath + 'company_interview' + query),
        // 企業情報取得API
        this.$http.secured.get(this.apiPath + 'company_info' + query),
        // 応募について取得API
        this.$http.secured.get(this.apiPath + 'about_apply' + query),
        // コード設定取得API
        this.$http.secured.get(this.apiPath + 'code_settings' + query),
        // マッチング条件設定取得API
        this.$http.secured.get(this.apiPath + 'matching_settings' + query),
        // パーソナリティ設定取得API
        this.$http.secured.get(this.apiPath + 'personality_matching' + query)
      ]).then(([
        jobInfoResponse,
        companyInterviewResponse,
        companyInfoResponse,
        aboutApplyResponse,
        codeSettingResponse,
        matchingSettingResponse,
        personalityMatchingsResponse]) => {
        this.$set(this, 'jobInfo', jobInfoResponse.data)
        this.$set(this, 'companyInterview', companyInterviewResponse.data)
        this.$set(this, 'companyInfo', companyInfoResponse.data)
        this.$set(this, 'aboutApply', aboutApplyResponse.data)
        this.$set(this, 'codeSetting', codeSettingResponse.data)
        this.$set(this, 'matchingSetting', matchingSettingResponse.data)
        this.$set(this, 'personalityMatchings', personalityMatchingsResponse.data)
        this.isFinishCreated = true
      })
    },
    // スマホプレビュー表示
    openSpPreview () {
      // BOSS-CとADMからで呼び出す画面を変える且つqueryにfolderChildIdがある場合は過去掲載を表示する必要があるため、スマホプレビュー画面にもqueryを設定
      const routeData = this.isCompanyStaff
        ? this.$router.resolve(
          this.$route.query.folderChildId
            ? { name: 'confirmPreviewJobSp', params: { jobId: this.jobId }, query: { folderChildId: this.$route.query.folderChildId } }
            : { name: 'confirmPreviewJobSp', params: { jobId: this.jobId } }
        )
        : this.$router.resolve(
          this.$route.query.folderChildId
            ? { name: 'admConfirmPreviewJobSp', params: { companyId: this.$route.params.companyId, jobId: this.jobId }, query: { folderChildId: this.$route.query.folderChildId } }
            : { name: 'admConfirmPreviewJobSp', params: { companyId: this.$route.params.companyId, jobId: this.jobId } }
        )
      window.open(routeData.href, `window_sp_${this.jobId}`, 'width=414,height=736,scrollbars=1')
    }
  }
}
</script>
